const vaccinationEvent =
{
    about       : 'Vaccin:',
    datePattern : 'L',
    date        : 'Date:' ,
    empty       : '----'
};

export default vaccinationEvent ;